<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MUbZ5r/tc-custom/9781497688957.jpg?1720280630260" alt="This image is the cover for the book Boy on a Black Horse"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boy on a Black Horse
      </h1>
      <p class="bookDescription body article font2">
        <b>Gray’s life changes forever when she meets a boy as wild as an untamed stallion</b><br/><br/> When Chav walks into Gray’s class at school for the first time dressed all in black, with wild hair and fierce eyes, Gray knows that her life is about to change. What she doesn’t yet know is that her mysterious new classmate is as fascinated by her as she is by him.<br/><br/> Gray and Chav are drawn to each other by their shared love of horses. But Chav’s home life is more complicated than Gray could ever have imagined. Chav is a Gypsy and doesn’t trust <i>gadjo</i>, or non-Gypsy people. He and his siblings have run away from a painful past and he will do anything to defend his family. But when his brother and sister suddenly get sick, Chav needs help—Gray’s help. And earning Chav’s trust turns out to be harder than breaking a wild horse. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy Springer
      </h2>
      
      <p class="authorDescription body article">Nancy Springer is the award-winning author of more than fifty books, including the Enola Holmes and Rowan Hood series and a plethora of novels for all ages, spanning fantasy, mystery, magic realism, and more. She received the James Tiptree, Jr. Award for&#160;<I>Larque on the Wing</I> and the Edgar Award for her juvenile mysteries&#160;<I>Toughing It&#160;</I>and&#160;<I>Looking for Jamie Bridger</I>,&#160;and she has been nominated for numerous other honors. Springer currently lives in the Florida Panhandle, where she rescues feral cats and enjoys the vibrant wildlife of the wetlands.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?168f5479